export default __webpack_public_path__ + "static/media/ols_people.4801fa71.svg";